export default __webpack_public_path__ + "static/media/black_cat.51ff20c0.png";